import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { getSite } from '../../infrastructure/site/SiteProvider';
import { Image } from '../../uiComponents/layout/Image';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { Row, Col, Form } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { EmailFormGroup, PasswordFormGroup } from '../../uiComponents/input/FormGroups';
import { ValidationResult } from '../../infrastructure/ValidationResult';
import SubmitButton from '../../uiComponents/input/SubmitButton';
import { Login } from '../../models/Login';
import { isAuthenticated } from '../../infrastructure/Security';

interface EmailProps extends RouteComponentProps<any> {

}

interface EmailState {
    login: Login;
    token?: string;
    isSubmitting: boolean;
    validationResult?: ValidationResult;
    erAlleredeLoggetInd?: boolean;
}

class EmailLogin extends React.Component<EmailProps, EmailState> {
    constructor(props: EmailProps) {
        super(props);

        const login = new Login();
        login.email = '';
        login.password = '';

        const erLoggetInd = isAuthenticated();

        this.state = { login: login, token: undefined, isSubmitting: false, erAlleredeLoggetInd: erLoggetInd };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onChange(fieldName: string, value: any) {
        const loginState = this.state.login;
        loginState[fieldName] = value;

        this.setState({ login: loginState });
    }

    onSubmit() {
        const self = this;
        self.setState({ isSubmitting: true });
        createApiCaller().loginAsExternalBruger(this.state.login).then(response => {
            if (response.data && response.data.token) {
                self.onAuthenticated(response.data);
            } else {
                self.setState({ validationResult: response, isSubmitting: false });
            }
        });
    }

    onAuthenticated(json: any) {
        localStorage.setItem('token', json.token);
        this.setState({ token: json.token, isSubmitting: false });
    }

    render() {
        const { token, erAlleredeLoggetInd } = this.state;
        if (token || erAlleredeLoggetInd) {
            return <Redirect to='/' />;
        }

        const text = (
            <div>
                <p>For at bruge {getSite().navn} skal du logge ind.</p>
                <br />
            </div>
        );

        return (
            <PageWrapper>
                <ContentWrapper>
                    <SectionGroup>
                        <Section>
                            <Form onSubmit={this.onSubmit}>
                                <div id='login-page'>
                                    <Row>
                                        <Col md={4} className='image'>
                                            <Image source='login-person.png' />
                                        </Col>
                                        <Col md={6}>
                                            <h1>Velkommen</h1>
                                            {text}
                                            <EmailFormGroup 
                                                errorMessages={this.state.validationResult === undefined ? [] : this.state.validationResult.errorMessages}
                                                label='Email*'
                                                name='email'
                                                placeholder='Indtast email'
                                                value={this.state.login.email}
                                                onChange={this.onChange}
                                            />
                                            <PasswordFormGroup 
                                                errorMessages={this.state.validationResult === undefined ? [] : this.state.validationResult.errorMessages}
                                                label='Password*'
                                                name='password'
                                                placeholder='Indtast password'
                                                value={this.state.login.password}
                                                onChange={this.onChange}
                                            />
                                            <SubmitButton isSubmitting={this.state.isSubmitting}>{this.state.isSubmitting ? 'Vent...' : 'Login'}</SubmitButton>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col mdOffset={4} md={6}>
                                            <br />
                                            <a href='/eksternadgang/nulstil'>Har du glemt din adgangskode?</a> 
                                        </Col>
                                    </Row>
                                </div>
                            </Form>
                        </Section>
                    </SectionGroup>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default EmailLogin;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/login/EmailLogin.tsx